import AxiosClient from "../../services/axios.services";

class JobPositionServices {
  getJobPositions = (params, iType) =>
    AxiosClient.get(
      iType === 1 ? "/api/app/Formal_Puesto/" : "/api/app/Funcional_Puesto/",
      {
        headers: { "Content-Type": "application/json" },
        params: params,
      }
    );
  saveJobPosition = (data, iType) =>
    AxiosClient.post(
      iType === 1 ? "/api/app/Formal_Puesto/" : "/api/app/Funcional_Puesto/",
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  editJobPosition = (id, data, iType) =>
    AxiosClient.put(
      iType === 1
        ? `/api/app/Formal_Puesto/${id}/`
        : `/api/app/Funcional_Puesto/${id}/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  deleteJobPosition = (id, iType) =>
    AxiosClient.delete(
      iType === 1
        ? `/api/app/Formal_Puesto/${id}/`
        : `/api/app/Funcional_Puesto/${id}/`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
}

export default new JobPositionServices();
